(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["greg-helmet-personalization"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.greg-helmet-personalization').forEach((block)=>{const id=block.querySelector('[form]')?.getAttribute('form');const form=id?document.getElementById(id):null;if(form)form.enctype='multipart/form-data'});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["greg-quad-configurator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('greg-quad-configurator')) {
    customElements.define(
      'greg-quad-configurator',
      class extends HTMLElement {
        connectedCallback() {
          this.catalog = JSON.parse(this.querySelector('[data-vehicle-catalog]').textContent);
          this.brand = this.querySelector('[data-brand]');
          this.model = this.querySelector('[data-model]');
          this.year = this.querySelector('[data-year]');
          this.form = document.getElementById(this.dataset.productFormId);

          if (this.form) this.form.enctype = 'multipart/form-data';

          Object.keys(this.catalog).forEach((brand) => this.addOption(this.brand, brand));
          for (let year = 2027; year >= 1987; year -= 1) this.addOption(this.year, String(year));

          this.brand.addEventListener('change', () => this.updateModels());
          this.model.addEventListener('change', () => this.updateModelTier());
          this.updateModelTier();
        }

        addOption(select, value) {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = value;
          select.append(option);
        }

        updateModels() {
          const placeholder = this.model.options[0];
          this.model.replaceChildren(placeholder);
          const models = this.catalog[this.brand.value] || [];
          models.forEach((model) => this.addOption(this.model, model));
          this.model.disabled = models.length === 0;
          this.updateModelTier();
        }

        updateModelTier() {
          const model = this.model.value;
          const tiers = {
            '159 €': ['YFZ50', 'YFM90', 'YFM110', 'LT-Z50', 'LT-Z90', 'KFX50', 'KFX90']
          };
          let tier = model ? '239 €' : '159 €';

          Object.entries(tiers).some(([price, models]) => {
            if (!models.includes(model)) return false;
            tier = price;
            return true;
          });

          document.dispatchEvent(
            new CustomEvent('greg:model-tier-change', {
              detail: { tier, model }
            })
          );
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["greg-vehicle-configurator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('greg-vehicle-configurator')) {
    customElements.define(
      'greg-vehicle-configurator',
      class extends HTMLElement {
        connectedCallback() {
          this.catalog = JSON.parse(this.querySelector('[data-vehicle-catalog]').textContent);
          this.brand = this.querySelector('[data-brand]');
          this.model = this.querySelector('[data-model]');
          this.year = this.querySelector('[data-year]');
          this.form = document.getElementById(this.dataset.productFormId);

          if (this.form) this.form.enctype = 'multipart/form-data';

          Object.keys(this.catalog).forEach((brand) => this.addOption(this.brand, brand));
          const minYear = this.dataset.productHandle === 'kit-deco-100-perso-fonds-de-plaques' ? 1986 : 2000;
for (let year = 2027; year >= minYear; year -= 1) this.addOption(this.year, String(year));

          this.brand.addEventListener('change', () => this.updateModels());
          this.model.addEventListener('change', () => this.updateModelTier());
          this.updateModelTier();
        }

        addOption(select, value) {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = value;
          select.append(option);
        }

        updateModels() {
          const placeholder = this.model.options[0];
          this.model.replaceChildren(placeholder);
          const models = this.catalog[this.brand.value] || [];
          models.forEach((model) => this.addOption(this.model, model));
          this.model.disabled = models.length === 0;
          this.updateModelTier();
        }

        updateModelTier() {
          const model = this.model.value;
          const tiers = {
            '129 €': ['50 PW', '80 PW'],
            '139 €': ['50 TTR', '90 TTR', '110 TTR', '50 SX', '50 MC'],
            '159 €': ['125 TTR', '65 YZ', '65 SX', '110 KLX', '140 KLX', '65 KX', '65 MC', '65 TC'],
            '179 €': ['85 YZ', '85 RM', '85 CR', '85 KX', '112 KX', '85 TM', '85 MC', '85 TC']
          };
          let tier = model ? '199 €' : '129 €';

          Object.entries(tiers).some(([price, models]) => {
            if (!models.includes(model)) return false;
            tier = price;
            return true;
          });

          document.dispatchEvent(
            new CustomEvent('greg:model-tier-change', {
              detail: { tier, model }
            })
          );
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["greg-vintage-configurator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('greg-vehicle-configurator')) {
    customElements.define(
      'greg-vehicle-configurator',
      class extends HTMLElement {
        connectedCallback() {
          this.catalog = JSON.parse(this.querySelector('[data-vehicle-catalog]').textContent);
          this.brand = this.querySelector('[data-brand]');
          this.model = this.querySelector('[data-model]');
          this.year = this.querySelector('[data-year]');
          this.form = document.getElementById(this.dataset.productFormId);

          if (this.form) this.form.enctype = 'multipart/form-data';

          Object.keys(this.catalog).forEach((brand) => this.addOption(this.brand, brand));
          const yearStart = Number(this.dataset.yearStart || 2000);
          const yearEnd = Number(this.dataset.yearEnd || 1986);
          for (let year = yearStart; year >= yearEnd; year -= 1) this.addOption(this.year, String(year));

          this.brand.addEventListener('change', () => this.updateModels());
          this.model.addEventListener('change', () => this.updateModelTier());
          this.updateModelTier();
        }

        addOption(select, value) {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = value;
          select.append(option);
        }

        updateModels() {
          const placeholder = this.model.options[0];
          this.model.replaceChildren(placeholder);
          const models = this.catalog[this.brand.value] || [];
          models.forEach((model) => this.addOption(this.model, model));
          this.model.disabled = models.length === 0;
          this.updateModelTier();
        }

        updateModelTier() {
          const model = this.model.value;
          const tiers = {
            '129 €': ['50 PW', '80 PW'],
            '139 €': ['50 TTR', '90 TTR', '110 TTR', '50 SX', '50 MC'],
            '159 €': ['125 TTR', '65 YZ', '65 SX', '110 KLX', '140 KLX', '65 KX', '65 MC', '65 TC'],
            '179 €': ['85 YZ', '85 RM', '85 CR', '85 KX', '112 KX', '85 TM', '85 MC', '85 TC']
          };
          let tier = '199 €';

          Object.entries(tiers).some(([price, models]) => {
            if (!models.includes(model)) return false;
            tier = price;
            return true;
          });

          document.dispatchEvent(
            new CustomEvent('greg:model-tier-change', {
              detail: { tier, model }
            })
          );
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
